module.exports = __webpack_public_path__ + "img/volume-mute.f99fbe48.svg";